import React from "react";
import HeaderText from "../../../admin/components/headerText/HeaderText";
import DateRangePicker from "../../../admin/components/dashboard/customs/DateRangePicker";
import YearSelector from "../../../admin/components/dashboard/customs/YearSelector";
import CompTables from "./CompTables";
import { useDateFilter } from "../../../contexts/dashboard/DateFilterContext";

const Comp: React.FC = () => {
  const dateFilter = useDateFilter();

  const startDate = dateFilter?.startDate ?? "";
  const endDate = dateFilter?.endDate ?? "";
  const selectedYear = dateFilter?.selectedYear ?? new Date().getFullYear();
  return (
    <section>
      <section className="flex flex-col lg:flex-row justify-between items-center">
        <HeaderText text="companies" />
      </section>
      <main>
        <div className="flex items-center space-x-4 mt-4 py-4 lg:mt-0">
          <DateRangePicker />

          <YearSelector />
        </div>
      </main>
      <CompTables
        startDate={startDate}
        endDate={endDate}
        selectedYear={selectedYear}
      />
    </section>
  );
};

export default Comp;
